import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Button from 'design-system/components/Button';
import Stack from 'design-system/components/Stack';
import { Heading, Paragraph } from 'design-system/components/Text';
import NotFoundIllustration from 'images/dashboard/not-found.svg';

const NullStateWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const NullImage = styled(NotFoundIllustration)`
  max-width: 600px;
  height: auto;
  margin-left: 180px; // Visually center the image
`;

const Header = styled(Stack)`
  margin-top: ${Spacing[9]};
  margin-bottom: ${Spacing[8]};
  text-align: center;
`;

interface NullStateProps {
  message?: string;
  backRoute?: string;
}

const NullState = ({ backRoute, message }: NullStateProps) => {
  return (
    <NullStateWrapper data-test='null-state'>
      <NullImage />
      <Header>
        <Heading size='lg'>Sorry!</Heading>
        <Paragraph size='lg' color='primary' data-test='null-state__message'>
          {message || 'We can’t seem to find the page you were looking for. Refresh and try again?'}
        </Paragraph>
      </Header>

      <Button data-test='null-state__go-back-link' to={backRoute || '/dashboard'} width='button'>
        Go Back
      </Button>
    </NullStateWrapper>
  );
};

export default NullState;
